import Divider from "../../componets/Divider";
import TextBox from "../../componets/TextBox";
import designData from "../../data/staffAugmentationServiceDesign2.json";

export default function Section3() {
  return (
    <div className="Section3">
      <div className="w-[90%] my-[24px] md:mb-0 md:w-[61%] mx-auto text-center">
        <h2 className="mx-auto text-center text-[24px] leading-[32px] md:text-[34px] font-bold md:leading-[41px] text-[#151515] mt-[40px]">
          Our Expertise And Services for
          <span className="text-[#DA2128]"> Staff Augmentation</span>
        </h2>

        <p className="pt-[1%] text-[16px] font-open text-[#373737]">
          Mean3 offers exceptional Staff Augmentation services for critical IT
          to help you scale and optimize your project development process.
        </p>
      </div>

      <TextBox
        data={designData}
        containerStyle="text-center"
        oddStyle="bg-[#f5f5f5]"
        evenStyle="bg-[#f5f5f5]"
        boxStyle="xs:w-[40%] md:w-[30%] xl:w-[26%] w-full"
        titleStyle="text-[18px] font-bold leading-[20px] text-[#888888] mt-5 mb-[10px]"
        imgStyle="w-[26%] mx-auto"
      />

      <Divider />
    </div>
  );
}
